var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.16732V7.33398C5.5 4.29982 6.41667 1.83398 11 1.83398C15.5833 1.83398 16.5 4.29982 16.5 7.33398V9.16732",
    stroke: "#4E008E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 16.9583C12.2658 16.9583 13.2918 15.9323 13.2918 14.6667C13.2918 13.401 12.2658 12.375 11.0002 12.375C9.73451 12.375 8.7085 13.401 8.7085 14.6667C8.7085 15.9323 9.73451 16.9583 11.0002 16.9583Z",
    stroke: "#4E008E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5835 20.166H6.41683C2.75016 20.166 1.8335 19.2493 1.8335 15.5827V13.7493C1.8335 10.0827 2.75016 9.16602 6.41683 9.16602H15.5835C19.2502 9.16602 20.1668 10.0827 20.1668 13.7493V15.5827C20.1668 19.2493 19.2502 20.166 15.5835 20.166Z",
    stroke: "#4E008E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.fa809c733cdd9cc7fc5adee9b7588ca8.svg";
export { ForwardRef as ReactComponent };